import {  useEffect, useState } from "react";
import { useToasts } from "react-toast-notifications";

import useFormOptionsApi from "./useFormOptionApi";
import useFormOptions from "./useFormOptions";
import prJson from "components/jsonData/purchase.json";
import { useSelector } from "react-redux";

const useMinorOptions = (expenseType) => {
  const { addToast } = useToasts();
  const [minorTypeOption, setMinorTypeOption] = useState([]);
  const [subCategoryList,setSubCategoryList] = useState([])
  const [minorTypeValue,setMinorTypeValue] = useState("")
  const subCategoryList1 = useSelector((state) => state.subCategory);

  useEffect(() => {
    if (subCategoryList1 && subCategoryList1.length > 0) {
      const filteredOptions = subCategoryList1.filter(item => item.expTyp === expenseType);
      setSubCategoryList(filteredOptions);
    }
  }, [subCategoryList1, expenseType]);
  
  const {
    createSubCategoryApi,
    deleteSubCategoryApi,
    editSubCategoryApi,
    getSubCategoryApi
  } = useFormOptionsApi();

  const {formOptionsList} = useFormOptions(expenseType);

  
  const getMinorOptions = (expenseId,minorId)=>{
    getSubCategoryApi(expenseId).then((subCatResult) => {
        if (subCatResult.success) {
          setSubCategoryList(subCatResult)
          const minorOpt = subCatResult.data.map((item) => ({
            ...item,
            label: item?.lab,
            value: item?.val,
            id: item?._id,
          }));
          
          setMinorTypeOption(minorOpt);
          if(minorId){

            const subCat = minorOpt.find((opt) => opt.id === minorId);
            if (subCat) {
            setMinorTypeValue({
            label: subCat?.label,
            value: subCat?.value,
            id: subCat?._id,
          });
          }
      }
      else{
        setMinorTypeValue("")
      }
        }
      });
  }

  const createSubCategory = (category, expenseData) => {
    const option = formOptionsList.find((data) => data._id === expenseData?.id);
    if (option){
        createSubCategoryApi(option._id, category,expenseType).then((result) => {
          if (result.success) {
            getMinorOptions(expenseData?.id,result.data.id)        
            addToast(prJson.success.createdSub, { appearance: 'success' });
          } else {
            addToast(result.message, { appearance: 'error' });
          }
        });
    }
  };

  const deleteSubCategory = (expenseId,option) => {
    const id = option?._id;
    if (id) {
        deleteSubCategoryApi(id).then((result) => {
          if (result.success) {
            getMinorOptions(expenseId,id)        
            addToast(prJson.success.deletedSub, { appearance: 'success' });
          } else {
            addToast(result.message, { appearance: 'error' });
          }
        });
    }
  };
 
  const editSubCategory = (expenseId,option,newValue) => {
    editSubCategoryApi( option?._id, newValue,expenseType).then((result) => {
      if (result.success) {
        getMinorOptions(expenseId,option?._id)        
        addToast(prJson.success.updatedSub, { appearance: 'success' });
      } else {
        addToast(result.message, { appearance: 'error' });
      }
    });
  };
  return {
    subCategoryList,
    minorTypeOption,
    createSubCategory,
    deleteSubCategory,
    editSubCategory,
    getMinorOptions,
    minorTypeValue,
    setMinorTypeValue
  };
};

export default useMinorOptions;
